export default __webpack_public_path__ + "static/media/misc-bathtubA-1024w.29bb846d.webp";